export default ({ leftColumn, rightColumn }) => ({
  left: leftColumn.value,
  leftAlignment: leftColumn.alignment,
  right: rightColumn.value,
  rightAlignment: rightColumn.alignment,
});
